<section *ngIf="sections3 && !isSubModule">
  <div class="footer-modal-overlay" *ngIf="showFooterModal && isExpanded && !isTaskModule" (click)="showFooterModal = false; isExpanded = false"></div>

  <div class="footer-modal" [class.expanded]="isExpanded" *ngIf="showFooterModal  && !isTaskModule">
    <div class="footer-header">
      <div class="footer-controls">
        <div class="footer-minimize" *ngIf="isExpanded" (click)="isExpanded = false"><i class="fa-regular fa-chevron-down"></i></div>
        <div class="footer-close" (click)="showFooterModal = false"><i class="fa-regular fa-xmark"></i></div>
      </div>
    </div>
    <div class="footer-content">
      <!-- With images -->
      <div class="footer-text" *ngIf="isBigFour">
      <h3>{{sections3.title}}</h3>
      <p>{{sections3.description}}</p>
        <a class="footer-link" (click)="isExpanded = true" *ngIf="isBigFour && !isExpanded">{{sections3.linkLabel}}</a>
      </div>
      <!-- Without Images -->
      <div class="footer-text-no-w"  *ngIf="!isBigFour">
      <h3>{{sections3.title}}</h3>
      <p>{{sections3.description}}</p>
        <a class="footer-link" (click)="isExpanded = true" *ngIf="isBigFour && !isExpanded">{{sections3.linkLabel}}</a>
      </div>
      <div class="footer-image" *ngIf="isBigFour && !isExpanded">
        <img [src]="sections3.footerImg" alt="Learn Footer">
      </div>
    </div>
    <div class="footer-expanded-content" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'" *ngIf="isBigFour">
      <!-- put your cards or expanded grid here -->
      <div class="footer-card-grid">
        <div class="footer-card" *ngFor="let card of sections3.cards">
          <img [src]="card.icon" />
          <div class="footer-card-wrapper">
            <h4>{{card.title}}</h4>
            <p>{{card.description}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-learn-more" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'" [ngClass]="{'d-none': !isExpanded}">
      <i class="fa-regular fa-circle-info info-icon"></i>
      <span class="learn-text">
        To learn more about these features, please visit our academy or book a free training session with our team of experts
      </span>
      <div class="learn-buttons">
        <button class="btn-outline-purple" (click)="goToLearnMore()"><i class="fa-regular fa-graduation-cap"></i>&nbsp;Learn</button>
        <button class="btn-outline-purple" (click)="onClaimFreeSessionDirect()"><i class="fa-regular fa-calendar-lines"></i>&nbsp;Free Training</button>
      </div>
    </div>
  </div>

  <!-- FOOTER SPECIFICALLY FOR TASK -->
  <div class="footer-modal-task" [class.expanded]="isExpanded" *ngIf="showFooterModal && isTaskModule">
    <div class="footer-header">
      <div class="footer-controls">
        <div class="footer-minimize" *ngIf="isExpanded" (click)="isExpanded = false"><i class="fa-regular fa-chevron-down"></i></div>
        <div class="footer-close" (click)="showFooterModal = false"><i class="fa-regular fa-xmark"></i></div>
      </div>
    </div>
    <div class="footer-content">
      <div class="footer-text-no-w">
      <h3>{{sections3.title}}</h3>
      <p>{{sections3.description}}</p>
        <a class="footer-link" (click)="isExpanded = true" *ngIf="isBigFour && !isExpanded">{{sections3.linkLabel}}</a>
      </div>
      <div class="footer-image" *ngIf="isBigFour && !isExpanded">
        <img [src]="sections3.footerImg" alt="Learn Footer">
      </div>
    </div>
    <div class="footer-expanded-content" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'" *ngIf="isBigFour">
      <!-- put your cards or expanded grid here -->
      <div class="footer-card-grid">
        <div class="footer-card" *ngFor="let card of sections3.cards">
          <img [src]="card.icon" />
          <div class="footer-card-wrapper">
            <h4>{{card.title}}</h4>
            <p>{{card.description}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-learn-more" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'" [ngClass]="{'d-none': !isExpanded}">
      <i class="fa-regular fa-circle-info info-icon"></i>
      <span class="learn-text">
        To learn more about these features, please visit our academy or book a free training session with our team of experts
      </span>
      <div class="learn-buttons">
        <button class="btn-outline-purple" (click)="goToLearnMore()"><i class="fa-regular fa-graduation-cap"></i>&nbsp;Learn</button>
        <button class="btn-outline-purple" (click)="onClaimFreeSessionDirect()"><i class="fa-regular fa-calendar-lines"></i>&nbsp;Free Training</button>
      </div>
    </div>
  </div>

</section>



<!-- <section class="section" *ngIf="sections3">
    <h2>{{ sections3.title }}</h2>
    <p>{{ sections3.description }}</p>
    <div class="video-grid">
        <div class="video-card" *ngFor="let video of sections3.videos">
            <div class="iframe-wrapper">
                <iframe
                 [src]="video.safeEmbedUrl"
                [title]="video.title "
                frameborder="0" loading="lazy" webkitallowfullscreen mozallowfullscreen allowfullscreen allow="clipboard-write" 
                ></iframe>
                <div class="click-overlay" (click)="openVideoModal(video.safeEmbedUrl)"></div>
            </div>
            <p class="video-label"><span>{{ video.title }}</span><small>{{ video.duration }}</small></p>
        </div>
    </div>
</section>

<div class="video-modal-overlay" *ngIf="showVideoModal" (click)="closeModalOnBackdrop($event)">
  <div class="video-modal-content" (click)="$event.stopPropagation()">
     <button class="modal-close" pTooltip="Close"(click)="closeVideoModal()"><i class="fa-regular fa-xmark" ></i></button>
      <div class="iframe-container">
      <iframe
        [src]="currentVideoUrl"
        title="Arcade Demo"
        loading="lazy"
        allowfullscreen
        allow="autoplay; clipboard-write"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms">
      </iframe>
    </div>
  </div>
</div> -->